<template>
  <v-menu offset-y class="app-menu" v-bind="resetProps">
    <template v-slot:activator="{ on, attrs }">
      <slot v-bind="{ on, attrs }" name="menu-btn">
        <v-toolbar-title v-on="on" class="app-menu-btn">
          <span>{{ title }}</span>
          <span class="menu-arrow" :class="attrs['aria-expanded'] !== 'false' ? 'app-menu-active' : ''"></span>
        </v-toolbar-title>
      </slot>
    </template>
    <slot name="menu-list">
      <v-list>
        <v-list-item>
          <v-list-item-title>
            <v-checkbox :label="$t('everything')" :ripple="false" color="red" value="red" hide-details></v-checkbox>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-checkbox :label="$t('comments_only')" color="red" value="red" :ripple="false" hide-details></v-checkbox>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-checkbox
              :label="$t('transaction_only')"
              color="red"
              value="red"
              :ripple="false"
              hide-details
            ></v-checkbox>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </slot>
  </v-menu>
</template>

<script>
import Vue from "vue";
import "./styles.scss";

const AppMenu = Vue.extend({
  name: "AppMenu",
  props: {
    title: {
      default: "",
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },
});
export default AppMenu;
</script>
